module.exports = __webpack_public_path__ + "static/img/challenge-3.188ccf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/characters/challenge-3.svg
// module id = 1r69
// module chunks = 1